import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import { bindActionCreators } from "redux";
// components
import { CustomAlertDialog } from "@gl-shared/shared/ui";
import { CustomFormInput } from "@gl-shared/shared/ui";
import { CustomButton } from "@gl-shared/shared/ui";
import { CustomFormDropdown } from "@gl-shared/shared/ui";
// helpers
import { hotelPanelRootUrl, pagesUrl } from "../../common/utils/panel-helpers/helpers";
// actions
import { employeesActionCreators } from "../../common/store/modules/employeesModule";

const EditEmployee = props => {
  const navigate = useNavigate();
  const outletContext = useOutletContext();

  const [employeeName, setEmployeeName] = useState("");
  const [employeeInitials, setEmployeeInitials] = useState("");
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [selectedConcierge, setSelectedConcierge] = useState({});
  const [errorField, setErrorField] = useState({
    name: false,
    initials: false,
    selectedConcierge: false
  });
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);

  let conciergeList = [];
  for (let concierge of props.allConcierges) {
    conciergeList.push({
      value: concierge?.id,
      label: concierge?.full_name
    });
  }
  useEffect(() => {
    setSelectedConcierge({
      value: props?.selectedEmployee?.admin?.id,
      label: props?.selectedEmployee?.admin?.full_name
    });
    setEmployeeName(props.selectedEmployee?.first_name);
    setEmployeeInitials(props.selectedEmployee?.initials);
    setEmployeeNumber(props.selectedEmployee?.employee_number);
  }, []);

  const handleConciergeChange = selectedConcierge => {
    setSelectedConcierge(selectedConcierge);
  };

  const handleSubmit = async () => {
    let errorCheck = true;
    let errorField = {
      name: false,
      initials: false,
      selectedConcierge: false
    };

    if (employeeName === "") {
      errorCheck = false;
      errorField.name = true;
    }
    if (employeeInitials === "") {
      errorCheck = false;
      errorField.initials = true;
    }
    if (Object.keys(selectedConcierge).length === 0) {
      errorCheck = false;
      errorField.selectedConcierge = true;
    }

    setErrorField(errorField);

    if (errorCheck === false) {
      return false;
    }

    props.updateEmployeeAction(
      employeeName,
      employeeInitials,
      employeeNumber,
      selectedConcierge.value,
      outletContext.handleFormMessage,
      outletContext.loadEmployees,
      navigate
    );
  };

  const handleDeleteEmployee = () => {
    setIsAlertDialogOpen(true);
  };

  const handleDeleteEmployeeConfirmation = async () => {
    setIsAlertDialogOpen(false);
    props.deleteEmployeeAction(outletContext.handleFormMessage, outletContext.loadEmployees, navigate);
  };

  const handleCloseAlertDialog = () => {
    setIsAlertDialogOpen(false);
  };

  return (
    <div className="employees component">
      <CustomAlertDialog
        isOpen={isAlertDialogOpen}
        handleClose={handleCloseAlertDialog}
        handleBtnLeft={handleCloseAlertDialog}
        handleBtnRight={handleDeleteEmployeeConfirmation}
        title={"ARE YOU SURE?"}
        content={"Are you sure you want to permanently delete this employee?"}
        btnLeftLabel={"CANCEL"}
        btnRightLabel={"DELETE"}
      />
      <div className="row">
        <div className="col-lg-6">
          <div className="ibox form__ibox">
            <div className="ibox-title">
              <h5>Edit Employee</h5>
            </div>

            <div className="ibox-content">
              <div className="hotel__form">
                <CustomFormInput
                  showTooltip={false}
                  name="employeeName"
                  id="name"
                  label="Name"
                  onInputChange={event => setEmployeeName(event.target.value)}
                  errorField={errorField}
                  isRequired={true}
                  value={employeeName}
                />

                <CustomFormInput
                  showTooltip={false}
                  name="employeeInitials"
                  id="initials"
                  label="Initials"
                  onInputChange={event => setEmployeeInitials(event.target.value)}
                  errorField={errorField}
                  isRequired={true}
                  value={employeeInitials}
                />
                <CustomFormInput
                  showTooltip={false}
                  name="employeeNumber"
                  id="employeeNumber"
                  label="Employee Number"
                  onInputChange={event => setEmployeeNumber(event.target.value)}
                  isRequired={false}
                  value={employeeNumber !== null ? employeeNumber : ""}
                />
                <CustomFormDropdown
                  showTooltip={false}
                  id="selectedConcierge"
                  alignRow={true}
                  label="Concierge User"
                  selectedItem={selectedConcierge}
                  onChange={selectedConcierge => handleConciergeChange(selectedConcierge)}
                  errorField={errorField}
                  placeholder={props?.selectedEmployee?.admin?.full_name}
                  optionsList={conciergeList}
                  isRequired={true}
                  isDisabled={false}
                  showStar={true}
                />
                <div className="form-group  row">
                  <div className="left-side">
                    <CustomButton
                      isDisabled={false}
                      mainClass="btn-red"
                      customClasses="btn-red--height-l"
                      onClick={handleDeleteEmployee}
                      buttonText="DELETE"
                    />
                  </div>
                  <div className="right-side">
                    <CustomButton
                      isDisabled={false}
                      mainClass="btn-gray"
                      customClasses="btn-gray--height-l"
                      onClick={() => {
                        navigate(`/${hotelPanelRootUrl}/${pagesUrl.employees}`);
                      }}
                      buttonText="CANCEL"
                    />
                    <CustomButton
                      isDisabled={false}
                      mainClass="btn-green"
                      customClasses="btn-green--height-l"
                      onClick={handleSubmit}
                      buttonText="SAVE"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  allConcierges: state.employees.allConcierges,
  selectedEmployee: state.employees.selectedEmployee
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateEmployeeAction: employeesActionCreators.updateEmployeeAction,
      deleteEmployeeAction: employeesActionCreators.deleteEmployeeAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditEmployee);
